import axios from "@main/axios";
import {MODAL_AUTO_CLOSE_TIMEOUT} from "@main/constants";
/**
* Сохранение в архив
**/
export class Archive {
    constructor(btn) {
        this.btn = btn;
        this.list = this.btn.closest(".js-list");
        this.filter = this.list.querySelector(".js-archive-filter");
        this.messagePlace = this.list.querySelector(".js-add-to-archive-error");
        this.modal = document.querySelector(".js-confirm-archive-modal");
        this.modalTitle = this.modal.querySelector(".js-confirm-archive-modal-title");
        this.confirmBtn = this.modal.querySelector(".js-archive-confirm-btn");
        this.modalBtnsWrap = this.modal.querySelector(".js-confirm-archive-modal-btns");
        this.modalBtnsClose = this.modal.querySelector(".js-close-archive-modal-btns");
        this.timeout = null;
        this.initEvents();
    }

    /**
     * Проверяет выводим ли мы архивные элементы в списке.
     */
    isFilterChecked() {
        return this.filter.classList.contains("current");
    }

    /**
     * Выбираем:
     * - если мы в архиве - те, что не отмечены.
     * - если мы не в архиве - те, что отмечены.
     */
    getChecks() {
        return [...this.list.querySelectorAll(".js-add-to-archive-check")].filter((check) => check.checked);
    }

    initEvents() {
        this.setChangeListener();

        this.list.addEventListener("setArchiveCheckEvents", () => {
            this.updateBtn();
            this.setChangeListener();
        });

        this.btn.addEventListener("click", (e) => {
            e.preventDefault();
            this.modalBtnsWrap.classList.remove("hidden");
            this.modalBtnsClose.classList.add("hidden");
            this.updateModalText();
            this.modal.dispatchEvent(new CustomEvent("openModal"));
        });

        this.confirmBtn.addEventListener("click", (e) => {
            e.preventDefault();
            this.sendData();
        });
    }

    /**
     * Добавить ивент изменения состояния чекбокса.
     */
    setChangeListener() {
        this.list.querySelectorAll(".js-add-to-archive-check").forEach((check) =>{
            check.addEventListener("change", () => {
                this.updateBtn();
                this.messagePlace.innerHTML = "";
            });
        });
    }

    /**
     * Дисэблим кнопку, если ничего не поменялось, меняем текст
     */
    updateBtn() {
        this.btn.disabled = !this.getChecks().length;
        if (this.isFilterChecked()) {
            this.btn.innerText = this.btn.dataset.removeText;
        } else {
            this.btn.innerText = this.btn.dataset.addText;
        }
    }

    /**
     * Установим текст модала с параметров кнопки.
     */
    updateModalText() {
        if (!this.modalTitle) {
            return;
        }
        if (this.isFilterChecked()) {
            this.modalTitle.innerText = this.btn.dataset.removeConfirmText;
        } else {
            this.modalTitle.innerText = this.btn.dataset.addConfirmText;
        }
    }

    /**
     * Отправка данных на сервер
     */
    sendData = async () => {
        try {
            if (this.confirmBtn.classList.contains("waiting")) {
                return;
            }
            this.messagePlace.innerHTML = "";
            this.confirmBtn.classList.add("waiting");
            const data = {
                items: this.getSelectedValues(),
                action: this.isFilterChecked() ? "remove" : "add"
            };
            const response = await axios({
                url: this.btn.dataset.url,
                data,
                method: "post",
            });
            this.confirmBtn.classList.remove("waiting");
            if (!response || !response.data || !response.data.data) {
                this.showSuccess("Что-то пошло не так. Пожалуйста перезагрузите страницу.");
            } else if (response.data.data.success) {
                this.showSuccess(response.data.data.message);
                this.list.dispatchEvent(new CustomEvent("loadList", {
                    detail: {resetNav: true}
                }));
            } else {
                this.showError(response.data.data.message);
            }
        } catch (error) {
            this.showError(error);
            this.confirmBtn.classList.remove("waiting");
        }
    }

    /**
     * Выбираем ИД элементов для сохранения
     */
    getSelectedValues() {
        let values = [];
        this.getChecks().forEach((check) =>{
            values.push(check.value);
        });
        return values;
    }

    /**
     * Показать сообщение об ошибке
     */
    showError(error) {
        this.modalTitle.innerHTML = "<div class='test-list__error'>" + error + "</div>";
        this.modalBtnsWrap.classList.add("hidden");
        this.modalBtnsClose.classList.remove("hidden");
    }

    /**
     * Показать сообщение об успехе
     */
    showSuccess(message) {
        this.modalTitle.innerHTML = "<div class='test-list__success'>" + message + "</div>";
        this.modalBtnsWrap.classList.add("hidden");
        this.modalBtnsClose.classList.remove("hidden");
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            this.modal.dispatchEvent(new CustomEvent("closeModal"));
        }, MODAL_AUTO_CLOSE_TIMEOUT);
    }
}

document.querySelectorAll(".js-add-to-archive-btn").forEach((btn) => new Archive(btn));
